var _rect, _path, _g, _path2, _path3, _circle, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg111(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 450",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "t"
  }, "1233\uD68C \uAFC8 \uC22B\uC790 \uB85C\uB610 \uD65C\uC6A9\uBC95") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "t"
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 450,
    rx: 28,
    fill: "#f4f0ff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120 230c-40-85 55-145 125-92 32-88 172-75 185 25 92-25 148 78 82 138H170c-35-10-54-35-50-71Z",
    fill: "#fff",
    stroke: "#8065c7",
    strokeWidth: 8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fontFamily: "sans-serif",
    fontSize: 36,
    fontWeight: 900,
    textAnchor: "middle",
    fill: "#172033"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 225,
    cy: 225,
    r: 48,
    fill: "#ffd666"
  }), /*#__PURE__*/React.createElement("text", {
    x: 225,
    y: 238
  }, "7"), /*#__PURE__*/React.createElement("circle", {
    cx: 335,
    cy: 225,
    r: 48,
    fill: "#b9e6dc"
  }), /*#__PURE__*/React.createElement("text", {
    x: 335,
    y: 238
  }, "14"), /*#__PURE__*/React.createElement("circle", {
    cx: 445,
    cy: 225,
    r: 48,
    fill: "#d9ccff"
  }), /*#__PURE__*/React.createElement("text", {
    x: 445,
    y: 238
  }, "?"))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M535 235h80",
    stroke: "#0f766e",
    strokeWidth: 9,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m590 208 33 27-33 27",
    fill: "none",
    stroke: "#0f766e",
    strokeWidth: 9
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 690,
    cy: 235,
    r: 62,
    fill: "#0f766e"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 690,
    y: 247,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 34,
    fontWeight: 900,
    fill: "#fff"
  }, "\uC790\uB3D9")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 390,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 30,
    fontWeight: 900,
    fill: "#172033"
  }, "\uC120\uBA85\uD55C \uAFC8 \uC22B\uC790\uB9CC \uB0A8\uAE30\uACE0 \uB098\uBA38\uC9C0\uB294 \uBB34\uC791\uC704\uB85C")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg111);
export default __webpack_public_path__ + "static/media/111-꿈숫자.2bd5811616713c98dbf17c4cec5ffd66.svg";
export { ForwardRef as ReactComponent };